import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { SessionService } from '../../../services/session.service';

import { Banco } from '../../../models/banco';
import { BancoService } from '../../../services/banco.service';

import { Validation } from '../../../config/validation';
import { SweetMessage } from '../../../config/sweet-message';


@Component({
	selector: 'app-banco-add',
	templateUrl: './banco-add.component.html',
	styleUrls: ['./banco-add.component.css'],
	providers: [BancoService,SessionService]
})
export class BancoAddComponent implements OnInit {
	public title: String;
	public banco: Banco;
	public msg: SweetMessage;
	myForm: FormGroup;
	public vl: Validation;
	public loading = false;

	constructor(
		private BancoService: BancoService,
		private ss: SessionService,
		public fb: FormBuilder,
	) {
		this.title = "Crear Banco";
	}

	ngOnInit() {
		//Inicializar Formulario
		this.onForm();
		//Inicializacion de Objectos
		this.msg = new SweetMessage();
		//Inicializacion de Objecto de validacion
		this.vl = new Validation();
		//Inicializacion de objecto Banco
		this.banco = new Banco();
	}

	onSubmit() {
		//setea valores del formulario a la entidad
		this.setValueEntity();
		this.loading = true;
		this.BancoService.save(this.banco).subscribe(
			res => {
				this.loading = false;
				this.msg.showMessage('success-message', res.message);
				this.banco = new Banco();
				this.onForm();
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message',err);
			}
		);
	}

	onForm() {
		this.myForm = this.fb.group({
			nombre: ['', [Validators.required, Validators.pattern(/[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]*/)]],
		});
	}

	setValueForm() {
		this.myForm.setValue({
			nombre: this.banco.nombre
		});
	}
	setValueEntity(){
		this.banco.nombre = this.myForm.controls['nombre'].value;
		this.banco.usuario_id = this.ss.getData('usuario_id');
		this.banco.empresa_id = this.ss.getData('empresa_id');
	}

	validErrorForm(campo){
		return this.vl.validErrorForm(campo,this.myForm);
	}

	validTypeMsgForm(nombre,campo){
		return this.vl.validTypeMsgForm(nombre,campo,this.myForm);
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/cobros/banco-add/banco-add.component.ts